// extracted by css-extract-rspack-plugin
export default {"layout":"Ifxebgd9OlcCuAgS","welcome":"zBOieUScKAcGVfEc","title":"IhXogbsO0_mmFwfP","card":"X40lkNplr14ehmI5","customRole":"OXa7SRMExwiF4_RA","actions":"tP_nqg7vVyUCg7j0"};